var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#111111",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0.5C36.9787 0.5 47.5 11.0213 47.5 24C47.5 36.9787 36.9787 47.5 24 47.5C11.0213 47.5 0.5 36.9787 0.5 24C0.5 11.0213 11.0213 0.5 24 0.5Z",
    stroke: "#111111",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2031 19.9297C21.5 19.5 20.8359 18.9922 20.2891 18.3281C21.1875 16.375 22.6328 15.125 23.2188 14.6172C23.2969 14.5781 23.3359 14.5391 23.375 14.5C23.2188 16.6875 24.0391 18.5625 25.25 20.0078V21.1797C24.3125 20.9453 23.2188 20.5547 22.2031 19.9297ZM26.5 21.3359V20.125C26.5 18.4062 27.8672 17 29.625 17H34L32.75 19.1875V25.75C32.75 29.2266 29.9375 32 26.5 32H23.2188L20.25 34.5L17.125 33.875L14 31.375L19.9766 29.3828C18.5703 28.6016 15.25 26.1016 15.25 21.375C15.25 18.875 16.6953 17.0781 17.3984 16.1797C17.5547 15.9844 17.6719 15.8672 17.75 15.75C18.7266 20.75 24 22.4297 26.5 22.625V21.375V21.3359ZM29.625 20.75C29.9375 20.75 30.25 20.4766 30.25 20.125C30.25 19.8125 29.9375 19.5 29.625 19.5C29.2734 19.5 29 19.8125 29 20.125C29 20.4766 29.2734 20.75 29.625 20.75Z",
    fill: "#111111",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/1_2.723b969703575f1879cdf43011d5d72c.svg";
export { ForwardRef as ReactComponent };